import React from "react";
import { PlusOutlined , CloseOutlined } from "@ant-design/icons";
import {
  Drawer,
  Button,
  PageHeader,
} from "antd";
import { useState } from "react";



import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import AccountGroupEntry from "../../components/masters/account-group/AccountGroupEntry";
import AccountGroupList from "../../components/masters/account-group/AccountGroupList";
import AccountGroupTableList from "../../components/masters/account-group/AccountGroupTableList";
import { DEFAULT_MASTER_DRAWER_WIDTH } from "../../utility/Constants";
import DrawableCloseIcon from "../../components/common/DrawableCloseIcon";











const AccountGroup = () => {
  const [visible, setVisible] = useState(false);
  const [accountGroupAddData, setAccountGroupAddData] = useState({
    group_id: 0,
    group_description: '',
    main_category: '',
    sub_category: '',
    group_alias: '',
    is_bank: 'N',
    group_parent_id: "",
    is_parent: 'N',
    is_active: "Y",
    mode: "ADD"
  });

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };
  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Group"
          subTitle=""
          extra={[
            <Button key="1" className="custom-button-white" shape="round" onClick={showDrawer} style={{border:0}}>
              <PlusOutlined /> Add
            </Button>,
          ]}
        ></PageHeader>

        <Drawer
          title = {
            <>
              <div>Group</div>
            </>
          }
          width={DEFAULT_MASTER_DRAWER_WIDTH}
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          closeIcon = {<><DrawableCloseIcon /></>}
          destroyOnClose={true}
        >
          <AccountGroupEntry data={accountGroupAddData} onDrawerClose={onClose} />
        </Drawer>

        <div className="tableView">
        <div className="form-content">
          <AccountGroupList />
          {/* <AccountGroupTableList /> */}
        </div>
        </div>

      </div>
    </div>
  );
};

export default AccountGroup;
